import tipoFaixaServices from '@/api/financial/tipoFaixaServices'

export default {
  loadTable({ commit }, pageConfig) {
    return tipoFaixaServices.loadTable(pageConfig).then(result => {
      commit('LOAD_LIST_TIPO_FAIXA', result.data.content)
      return result
    }).catch(err => err)
  },
  insertNewTipoFaixa({ commit }, data) {
    return tipoFaixaServices.insert(data).then(result => result).catch(error => error)
  },
  prepareToEditTipoFaixa({ commit }, data) {
    commit('PREPARE_TO_EDIT_TIPO_FAIXA', data)
  },
  editTipoFaixa({ commit }, data) {
    return tipoFaixaServices.update(data.id, data).then(result => result).catch(error => error)
  },
  resetTipoFaixa({ commit }) {
    commit('RESET_TIPO_FAIXA')
  },
  delete({ commit }, id) {
    return tipoFaixaServices.delete(id).then(result => result).catch(error => error)
  },
}
